import { useEffect } from "react";
import "./SplashWaiter.css";

function Spinner() {
  return <div className="splash-spinner" aria-label="Loading" />;
}

function SplashWaiter({ onReady }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onReady();
    }, 900);

    return () => clearTimeout(timer);
  }, [onReady]);

  return (
    <div className="splash-screen">
      <div className="splash-title">QrMenu Cameriere</div>
      <div className="splash-subtitle">Connessione sicura…</div>
      <Spinner />
    </div>
  );
}

export default SplashWaiter;
